import { clients } from './https';
import { useConfigStore } from 'state/store/config/useConfigStore';
import { getConfigurationSettings } from 'services/configuration-service';

interface GraphQLRequest {
  query: string;
  variables?: Record<string, any>;
}

interface GraphQLResponse<T = any> {
  data?: T;
  errors?: Array<{
    message: string;
    locations?: Array<{ line: number; column: number }>;
    path?: string[];
  }>;
}

interface GraphQLClient {
  query<T>(request: GraphQLRequest): Promise<T>;
  mutate<T>(request: GraphQLRequest): Promise<T>;
}

const getProjectKey = () => useConfigStore.getState().configurationSettings?.blocksKey || '';

const getGraphqlBaseUrl = async () => {
  const config = await getConfigurationSettings();
  return `https://${config.paths.baseUrl}${config.paths.data.gateway}`;
};

export const graphqlClient: GraphQLClient = {
  async query<T>(request: GraphQLRequest): Promise<T> {
    const projectKey = getProjectKey();
    const baseUrl = await getGraphqlBaseUrl();
    const payload = {
      query: request.query,
      variables: request.variables || {},
    };

    const response = await clients.post<GraphQLResponse<T>>(
      baseUrl,
      projectKey,
      JSON.stringify(payload),
      {
        'Content-Type': 'application/json',
        'x-blocks-key': projectKey,
      }
    );

    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }

    return (response.data as T) ?? ({} as T);
  },

  async mutate<T>(request: GraphQLRequest): Promise<T> {
    const projectKey = getProjectKey();
    const baseUrl = await getGraphqlBaseUrl();
    const payload = {
      query: request.query,
      variables: request.variables || {},
    };

    const response = await clients.post<GraphQLResponse<T>>(
      baseUrl,
      projectKey,
      JSON.stringify(payload),
      {
        'Content-Type': 'application/json',
        'x-blocks-key': projectKey,
      }
    );

    if (response.errors && response.errors.length > 0) {
      throw new Error(response.errors[0].message);
    }

    return response.data as T;
  },
};

export default graphqlClient;
